export const UserRolePrivilege = {
    FULL_ACCESS: 'Full Access',
    VIEW_ONLY: 'View Only',
    NO_ACCESS: 'No Access'
};
